import { ChatMapper } from "@/domain/mappers";
import { ChatMessageResponse, ChatResponse } from "../dtos/responses";
import { Chat, ChatMessage } from "@/domain/entities";
import moment from "moment";

export class ChatMapperImpl implements ChatMapper<
  ChatResponse,
  ChatMessageResponse
> {
  private defaultMessage =
    "Esta conversa foi criada automaticamente com paciente após a confirmação do agendamento.";

  toDomain(data: ChatResponse): Chat {
    const date = data.latest_message
      ? data.latest_message.created_at
      : data.created_at;

    return {
      id: data.id,
      formatted_date: this.getFormattedDate(
        data.latest_message ? data.latest_message.created_at : data.created_at,
      ),
      formatted_latest_message: data.latest_message
        ? data.latest_message.message
        : this.defaultMessage,
      last_message_date_timestamp: moment(date).valueOf(),
      unread_count: data.unread_count,
      user: data.user,
      psychologist: data.psychologist,
      created_at: data.created_at,
      status: data.status,
      pinned_by_user: data.pinned_by_user,
      archived_by_user: data.archived_by_user,
      pinned_by_psy: data.pinned_by_psy,
      archived_by_psy: data.archived_by_psy,
    };
  }

  toMessageDomain(data: ChatMessageResponse): ChatMessage {
    return {
      title: this.getFormattedDate(
        moment(data.created_at).format("YYYY-MM-DD"),
      ),
      id: data.id,
      message: data.message,
      date: data.created_at,
      is_edited: data.edited_at !== null,
      user: {
        id: data.user_id,
        name: data.user.name,
        profile_image: data.user.profile_image,
      },
    };
  }

  private getFormattedDate(date: string, showTodayAsString = false) {
    if (moment(date).isSame(moment(), "day")) {
      return showTodayAsString ? "Hoje" : moment(date).format("HH:mm");
    } else if (moment(date).isSame(moment().add(-1, "days"), "day")) {
      return "Ontem";
    }
    return moment(date).format("DD/MM/YYYY");
  }
}
